import { createSlice } from "@reduxjs/toolkit";

// Define the initial state for the saveFormDataSlice
const initialState = {
  loading: false,
  success: false,
  hasData: false,
  errorMessage: "",
  error: false,
  data: {},
};

// Create thesaveFormDataSlice using createSlice
const saveFormDataSlice = createSlice({
  name: "saveFormData", // Slice name
  initialState, // Initial state
  reducers: {
    saveForm(state, action) {
      state.loading = true;
      state.success = false;
      state.data = {};
      state.errorMessage = "";
      state.error = false;
      state.hasData = false;
    },
    saveFormSuccess(state, action) {
      state.loading = false;
      state.success = true;
      state.data = action.payload ?? {};
      state.errorMessage = "";
      state.error = false;
      state.hasData = true;
    },
    saveFormFailure(state, action) {
      state.loading = false;
      state.success = false;
      state.data = {};
      state.errorMessage = action.payload ?? "something went wrong";
      state.error = true;
      state.hasData = false;
    },
    resetSaveFormData(state,action){
        state.loading = false;
        state.success = false;
        state.data = {};
        state.errorMessage = "";
        state.error = false;
        state.hasData = false;
    }
  },
});

// Export the reducer functions as actions
export const {
  saveForm,
  saveFormSuccess,
  saveFormFailure,
  resetSaveFormData
} = saveFormDataSlice.actions;
// Export the reducer function itself
export default saveFormDataSlice.reducer;
